// extracted by mini-css-extract-plugin
export default {"secondaryPrice":"YP5ff","priceAndDiscount":"TTv5t"};